import React from "react";

const EmailNotificationsContext = React.createContext({});

export default EmailNotificationsContext;
